import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { registerPwa } from './pwa';
import { ThemeProvider } from './hooks/useTheme';
import { applyThemeToDocument, browserThemeStore } from './lib/theme';
import { requestPersistentStorage } from './lib/persistentStorage';
import './styles/global.css';

registerPwa();
applyThemeToDocument(browserThemeStore.getSnapshot());
void requestPersistentStorage();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
